/* types */
export const SET_STATE_MODAL = 'SET_STATE_MODAL'
export const SHOW_MODAL = 'SHOW_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'
export const SHOW_LOGIN_MODAL = 'SHOW_LOGIN_MODAL'
export const SHOW_SOCIAL_LOGIN_MODAL = 'SHOW_SOCIAL_LOGIN_MODAL'
export const SHOW_REGISTER_MODAL = 'SHOW_REGISTER_MODAL'
export const SHOW_COMMON_MODAL = 'SHOW_COMMON_MODAL'
export const HIDE_ALL_MODAL = 'HIDE_ALL_MODAL'
